import { useState } from 'react'
import { postDate } from '../apiCalls'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'

const NewDateFromDeck = (props) => {
    const setNewDateToggle = props.mods.setNewDateToggle
    const ideaName = props.mods.idea.name
    const ideaLocation = props.mods.idea.location
    const ideaDetails = props.mods.idea.details

    const [dateForm, setDateForm] = useState({
        name: ideaName,
        date: "",
        time: "",
        details: ideaDetails,
        dateName: "",
        dateImage: "",
        location: ideaLocation
    })

    const handleChange = (e) => {
        setDateForm((baseState) => ({
            ...baseState,
            [e.target.name]: e.target.value
        }))
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault()
            await postDate(dateForm)
            e.target.reset();
            handleClose()

        } catch(err) {
            console.log(err)
        }
    }

    function handleClose() {
        setNewDateToggle(false)
    }

    return (
        <div className="newDateContainer">
            <i className="bi bi-x-square closeIcon" onClick={handleClose}></i>
            <Container>
                <h2 className="">New Date</h2>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group className="sm-2" controlId="newDateName">
                                <Form.Label>Name: </Form.Label>
                                <Form.Control type='text' name="name" onChange={handleChange} value={dateForm.name}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDate">
                                <Form.Label>Date: </Form.Label>
                                <Form.Control type='date' name="date" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateTime">
                                <Form.Label>Time: </Form.Label>
                                <Form.Control type='time' name="time" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateLocation">
                                <Form.Label>Location: </Form.Label>
                                <Form.Control type='text' name="location" onChange={handleChange} value={dateForm.location}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDetails">
                                <Form.Label>Details: </Form.Label>
                                <Form.Control type='text' name="details" onChange={handleChange} value={dateForm.details}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDateName">
                                <Form.Label>Date's Name: </Form.Label>
                                <Form.Control type='text' name="dateName" onChange={handleChange}></Form.Control>
                            </Form.Group>
                            <Form.Group className="sm-2" controlId="newDateDateImage">
                                <Form.Label>Date's Photo: </Form.Label>
                                <Form.Control type='text' name="dateImage" onChange={handleChange}></Form.Control>
                            </Form.Group>
                        </Row>
                        <Row className="inputButtonRow mt-2">
                            <Col className="d-flex justify-content-center">
                                <Button variant="dark" type="submit" className="defaultButton altDateButton">Schedule Date</Button>
                            </Col>
                        </Row>
                    </Form>
            </Container>
        </div>
    )
}

export default NewDateFromDeck